
import ListingItem from '../ListingItem';
import '../../Styles/Sass/SimilarUser.scss';
function SimilarUser(){
  return(
    <section className='similaruser'>
      <h2 className='similaruser__title'>Similar User Profiles</h2>
      <div className='similaruser__list'>
        <ListingItem body={'Description description description description description description description description description description description description description description'} />
        <ListingItem body={'Description description description description description description description description description description description description description description'} />
      </div>
    </section>
  );
}
export default SimilarUser;